import { createContext, useState, useContext, ReactNode } from "react";
import { BorModal } from "./BorModal";

type BorModalContextType = {
  showBorModal: (reportId: string) => void;
  hideBorModal: () => void;
};

const BorModalContext = createContext<BorModalContextType>({
  showBorModal: () => {},
  hideBorModal: () => {},
});

export const BorModalProvider = ({ children }: { children: ReactNode }) => {
  const [reportId, setReportId] = useState<string | null>(null);

  const showBorModal = (id: string) => setReportId(id);
  const hideBorModal = () => setReportId(null);

  return (
    <BorModalContext.Provider value={{ showBorModal, hideBorModal }}>
      {children}
      {reportId && (
        <BorModal visible={true} onHide={hideBorModal} reportId={reportId} />
      )}
    </BorModalContext.Provider>
  );
};

export const useBorModal = () => useContext(BorModalContext);
